import { ContentBlock } from "../../types/contentBlock";
import { StackingCards } from "../../types/stackingCards";
import { linkQuery } from "./link";

export const stackingCardsQuery = `
    _type == "stackingCards" => {
        ...,
        type == "service" => {
          serviceCards[] {
            ...,
            service -> {
              title,
              description,
              serviceCategories
            },
            link {
                ${linkQuery}
            }
          }
        },
         type == "job" => {
          jobCards[] {
            ...,
            job -> {
              title,
              description,
              facts,
              "slug": metadata.slug.current
            },
          }
        },
        type == "custom" => {
          customCards[] {
            ...,
            link {
                ${linkQuery}
            }
          }
        },
        additionalSlides[] {
         ...,
          link {
              ${linkQuery}
          }
        }
      }
`


export const isStackingCardsBlock = (stackingCards: ContentBlock): stackingCards is StackingCards => {
  return stackingCards._type === 'stackingCards';
}

